import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa';
import './RegistrationSuccess.css';

const RegistrationSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Auto-redirect to login after 5 seconds
    const timer = setTimeout(() => {
      navigate('/login');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="success-page">
      <div className="success-container">
        <div className="success-card">
          <FaCheckCircle className="success-icon" />
          <h1 className="success-title">Registration Successful!</h1>
          <p className="success-message">
            Your account has been created successfully.
          </p>
          <p className="success-subtitle">
            You will be redirected to the login page in 5 seconds...
          </p>
          <button
            className="success-btn success-btn-primary"
            onClick={() => navigate('/login')}
          >
            Go to Login Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegistrationSuccess;
